// src/pages/Appli/AppliAdmin/ListingClients/components/AssociationsHeader.jsx

import React from "react";
import { Link } from "react-router-dom";

import {
  FaChartPie,
  FaChevronDown,
  FaChevronUp,
  FaMapMarkedAlt,
  FaPlus,
  FaSync,
} from "react-icons/fa";

export default function AssociationsHeader({
  totalCount = 0,
  loading = false,
  showAnalytics = false,
  onAdd,
  onRefresh,
  onToggleAnalytics,
}) {
  return (
    <header className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-blue-600 via-violet-600 to-fuchsia-600 p-5 text-white shadow-xl shadow-violet-950/10 sm:p-7">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 left-1/3 h-72 w-72 rounded-full bg-pink-300/15 blur-3xl" />

      <div className="relative flex flex-col gap-5 xl:flex-row xl:items-center xl:justify-between">
        <div>
          <div className="mb-2 inline-flex items-center rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs font-medium backdrop-blur">
            CRM MonAppliClub
          </div>

          <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">
            Associations, prospects et clients
          </h1>

          <p className="mt-2 max-w-2xl text-sm leading-6 text-white/80">
            Centralisez le suivi commercial, les contacts,
            les produits, les relances et les informations
            de vos associations.
          </p>

          <div className="mt-3 text-sm font-medium text-white/90">
            {totalCount.toLocaleString("fr-FR")} dossier
            {totalCount > 1 ? "s" : ""} enregistré
            {totalCount > 1 ? "s" : ""}
          </div>
        </div>

        <div className="flex flex-wrap gap-2">
          <Link
            to="/appli/carto-clients"
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/20 bg-white/10 px-4 py-2.5 text-sm font-medium text-white backdrop-blur transition hover:bg-white/20"
          >
            <FaMapMarkedAlt />
            Cartographie
          </Link>

          <button
            type="button"
            onClick={onToggleAnalytics}
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/20 bg-white/10 px-4 py-2.5 text-sm font-medium text-white backdrop-blur transition hover:bg-white/20"
          >
            <FaChartPie />

            {showAnalytics
              ? "Masquer l’analyse"
              : "Voir l’analyse"}

            {showAnalytics ? (
              <FaChevronUp className="text-xs" />
            ) : (
              <FaChevronDown className="text-xs" />
            )}
          </button>

          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/20 bg-white/10 px-4 py-2.5 text-sm font-medium text-white backdrop-blur transition hover:bg-white/20 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaSync
              className={loading ? "animate-spin" : ""}
            />
            Actualiser
          </button>

          <button
            type="button"
            onClick={onAdd}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-white px-4 py-2.5 text-sm font-semibold text-violet-700 shadow-lg shadow-violet-950/20 transition hover:bg-violet-50"
          >
            <FaPlus />
            Ajouter
          </button>
        </div>
      </div>
    </header>
  );
}